import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import { actions as loginactions } from "../../ui/Login/redux";
import { actions as sitetreeactions } from "../../services/SiteTree/redux";
import CSSModules from "react-css-modules";
import { ArrowBack, Menu } from "@material-ui/icons";
import { Button, Drawer, Select, MenuItem, Grid, Popover } from "@material-ui/core";
import TreeSelect from "../TreeSelect/TreeSelect";
import { actions as menuactions } from "../Menu/redux";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import Popup, { MenuAction } from "../PopupMenu/menu";

import styles from "./styles.scss";

import logo from "../../assets/avani-black-logo.png";

@CSSModules(styles, { allowMultiple: true })
class Header extends Component {
	anchorEl = null;

	constructor(props) {
		super(props);
		this.menuActions = [new MenuAction("Logout", () => this.props.logout(), () => this.props.isLoggedIn)];
	}

	render() {
		return (
			<div styleName="header">
				<div styleName="menu-header">
					<Menu styleName="menu-icon" onClick={() => this.props.toggleMenu()} />
					<img styleName="logo" src={logo} onClick={() => this.props.toggleMenu()} />
				</div>
				<div styleName="main">{this.props.showSelect && this.renderSiteSelect()}</div>
				<div styleName="namewrap">
					{this.props.isLoggedIn && (
						<Popup actions={this.menuActions} classes={styles}>
							<div styleName="username">{this.props.currentUsername}</div>
						</Popup>
					)}
					{!this.props.isLoggedIn && (
						<Button onClick={() => this.props.navigate("/Login")}>
							<strong>Login</strong>
						</Button>
					)}

					{/*<Button onClick={() => this.props.logout()}><strong>Logout</strong></Button>*/}
				</div>
			</div>
		);
	}

	renderSiteSelect() {
		return (
			<React.Fragment>
				<div
					styleName="select-anchor"
					ref={node => {
						this.anchorEl = node;
					}}
					onClick={this.props.openSelect}
				>
					<div>{this.props.currentSite ? this.props.currentSite.name.replace(/site_/gi, "") : ""}</div>
					<div style={{ flex: 1 }} />
					{this.props.selectOpen && (
						<div>
							<KeyboardArrowUp />
						</div>
					)}
					{!this.props.selectOpen && (
						<div>
							<KeyboardArrowDown />
						</div>
					)}
				</div>
				<Popover
					PaperProps={{ style: { borderRadius: "3px" } }}
					open={this.props.selectOpen}
					onClose={this.props.closeSelect}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left"
					}}
					anchorEl={this.anchorEl}
				>
					<div styleName="select-content">
						{this.props.menuTree.map((menuTreeNode, index) => (
							<div key={index}>{this.renderTreeNode(menuTreeNode, "")}</div>
						))}
					</div>
				</Popover>
			</React.Fragment>
		);
	}

	renderTreeNode(currentNode, currentPath) {
		let newPath = currentPath + currentNode.name;
		if (currentNode.isSite) {
			return (
				<div
					onClick={() => {
						this.props.selectSite(currentNode.site);
						this.props.closeSelect();
					}}
					styleName="select-node-site"
					currentsite={(
						!!this.props.currentSite && this.props.currentSite.name === currentNode.name
					).toString()}
				>
					<div>{currentNode.name.replace(/site_/gi, "")}</div>
				</div>
			);
		} else {
			return (
				<div styleName="select-node">
					<div
						onClick={() => this.props.toggleNode(newPath)}
						styleName="select-node-header"
						rootnode={(!!currentNode.isRoot).toString()}
					>
						<div>{currentNode.name.replace(/site_/gi, "")}</div>
					</div>
					<div
						expanded={(this.props.openNodes.indexOf(newPath) !== -1).toString()}
						styleName="select-node-content"
					>
						{currentNode.children.map((menuTreeNode, index) => (
							<div key={index}>{this.renderTreeNode(menuTreeNode, newPath)}</div>
						))}
					</div>
				</div>
			);
		}
	}
}

const bindAction = dispatch => {
	return {
		openSelect: () => dispatch(actions.openSelect()),
		closeSelect: () => dispatch(actions.closeSelect()),
		toggleNode: nodePath => dispatch(actions.toggleNode(nodePath)),

		selectSite: selectedSite => dispatch(sitetreeactions.setCurrentSite(selectedSite)),

		logout: () => dispatch(loginactions.logout()),
		toggleMenu: () => dispatch(menuactions.toggleOpen()),
		navigate: (uri, data) => dispatch(router.push(uri, data)),
		goBack: () => dispatch(router.goBack())
	};
};

const mapStateToProps = state => ({
	showSelect: state.header.showSelect,
	selectOpen: state.header.selectOpen,
	openNodes: state.header.openNodes,

	route: state.router.location.pathname,
	isLoggedIn: state.login.isLoggedIn,
	currentDetails: state.login.currentDetails,
	currentUsername: state.login.currentUsername,
	menuTree: state.sitetree.menuTree,
	currentSite: state.sitetree.currentSite
});

export default connect(
	mapStateToProps,
	bindAction
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js